import {
    ESTADO_LIMPIAR,
    ESTADO_CHANGE_PAGINA,
    ESTADO_CHANGE_PAGINATAB,
    ESTADO_CHANGE_PAGINAORIGEN,
    ESTADO_CHANGE_CLINICA,
    PAGE_PRINCIPAL,
} from './actions'



let initialState = {
    pagina: PAGE_PRINCIPAL,
    tab: null,
    proceso: null,
    detalleCodigo: 0,
    //pagina: PAGE_PRUEBA,
    cronometro: {inicio: null, acumulado: 0}, //{inicio, segundosAcumulados}
    clinica: {},
    prueba: 18,
}

export const estado = (state = initialState, action) => {
    switch (action.type) {
        case ESTADO_LIMPIAR:
            return limpiar(state);
        case ESTADO_CHANGE_PAGINA:
            return changePagina(state, action.newPagina);
        case ESTADO_CHANGE_PAGINATAB:
            return changePaginaTab(state, action.newPagina, action.newTab);
        case ESTADO_CHANGE_PAGINAORIGEN:
            return changePaginaOrigen(state, action.newPaginaOrigen);
        case ESTADO_CHANGE_CLINICA:
            return changeClinica(state, action.newClinica);
        default:
            return state;
    }
}


const limpiar = (state) => {
    return {initialState};
}

const changePagina = (state, newPagina) => {
    console.log("changePagina: ", newPagina);
    return { ...state, pagina: newPagina, tab: null };
}

const changePaginaTab = (state, newPagina, newTab) => {
    return { ...state, pagina: newPagina, tab: newTab };
}

const changePaginaOrigen = (state, newPaginaOrigen) => {
    return { ...state, paginaOrigen: newPaginaOrigen };
}

const changeClinica = (state, newClinica) => {
    return { ...state, clinica: newClinica };
}